/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class DivisionsDialog extends NoboxEntityDialog<DivisionsRow, any> {
        protected getFormKey() { return DivisionsForm.formKey; }
        protected getIdProperty() { return DivisionsRow.idProperty; }
        protected getLocalTextPrefix() { return DivisionsRow.localTextPrefix; }
        protected getNameProperty() { return DivisionsRow.nameProperty; }
        protected getService() { return DivisionsService.baseUrl; }
        protected getDeletePermission() { return DivisionsRow.deletePermission; }
        protected getInsertPermission() { return DivisionsRow.insertPermission; }
        protected getUpdatePermission() { return DivisionsRow.updatePermission; }

        protected form = new DivisionsForm(this.idPrefix);

        constructor() {
            super();
        }

        getSaveEntity() {
            var item = super.getSaveEntity();
            item.listAgent = [];
            return item;
        }
        save(callback) {
            if (this.validateForm()) {
                if (this.form.listAgent.value.length > 0) {
                    var agent = "";
                    this.form.listAgent.value.forEach((x, z) => {
                        if (z == 0) {
                            agent = x.UserId.toString();
                        } else {
                            agent = agent + "," + x.UserId.toString();
                        }
                    })
                    this.form.AgentIds.value = agent;
                    super.save(callback);
                } else {
                    Q.notifyError("List Agents can't be null");
                }
            }
        }

    }
}